// eslint-disable-next-line import/prefer-default-export
export const PURCHASE_SESSION_EXTENDED = 'Purchase Session Extended';
export const FIRST_DATA_PASSENGER_SWITCH_CLICKED = 'First Passenger Data Switch Clicked';
export const SWITCH_VALUE_PROP = 'Switch Value';
export const TICKET_INFO_BAR_DETAILS_CLICKED = 'InfoBar Details Clicked';
export const CHECKOUT_DETAILS_CLICKED = 'BookingReview Details Clicked';
export const SEARCH_CHANGED = 'Search Changed';
export const WALLET_PRICE_SWITCHED = 'Wallet Price Switched';
export const FILTERS_MODAL_OPENED = 'Filters Modal Opened';
export const RECOMMENDED_TRIPS_LOADED = 'Recommended Trips Loaded';
export const RECOMMENDED_TRIP_SELECTED = 'Recommended Trip Selected';
export const CONTINUE_WITH_SEATS = 'Continue With Seats';
export const SEAT_TAPPED = 'Seat Tapped';
export const SMART_SEATS_SELECTION = 'Smart Seats Selection';
export const FINGERPRINT_REQUESTED = 'Fingerprint Requested';
export const TERMINAL_GEOLOCATION_CLICKED = 'Terminal Geolocation Clicked';
export const PRICE_ALERT_CREATED = 'Price Alert Created';
export const PRICE_ALERT_OPENED = 'Price Alert Opened';
export const PRICE_ALERT_REDIRECTED = 'Price Alert Redirected';
export const PRICE_ALERT_FAILED = 'Price Alert Failed';
export const DOWNLOAD_APP_BANNER_PRESSED = 'Download App Banner Pressed';
export const BUS_TRACKER_BANNER_CLICKED = 'Interested in Geolocation';
export const ACCOMMODATION_PROMO_BANNER_CLICKED = 'Accommodation Promo Banner Clicked';
export const PRIVACY_BANNER_REJECTED = 'Privacy Banner Rejected';
export const HOW_TO_EXCHANGE_MODAL_OPENED = 'How To Exchange Modal Opened';
export const WALLET_ADD_BUTTON_PRESSED = 'Wallet Add Button Pressed';
export const EXCHANGE_BUTTON_CLICKED = 'Exchange Button Clicked';
export const APP_DOWNLOAD_MODAL_CONTINUE_IN_BROWSER = 'App Download Modal Continue In Browser';
export const APP_DOWNLOAD_MODAL_CONTINUE_IN_APP = 'App Download Modal Continue In App';
export const APP_DOWNLOAD_MODAL_CLOSED = 'App Download Modal Closed';
export const APP_DOWNLOAD_MODAL_SHOWED = 'App Download Modal Showed';
export const YAPE_INFO_MODAL_OPENED = 'Yape Info Modal Opened';
export const PRICING_DETAILS_DROPDOWN_OPENED = 'Pricing Details Dropdown Opened';
export const EXCHANGE_LOGIN_ATTEMPT = 'Exchange Login Attempt';
export const EXCHANGE_CHANGE_TO_INVOICE_ATTEMPT = 'Exchange Change To Invoice Attempt';
export const EXCHANGE_RESCHEDULE_ATTEMPT = 'Exchange Reschedule Attempt';
export const EXCHANGE_RUC_CORRECTION_ATTEMPT = 'Exchange RUC Correction Attempt';
export const EXCHANGE_MODIFY_TRIP_ATTEMPT = 'Exchange Modify Trip Attempt';

// Welcome Digital Discount Events
export const WELCOME_DIGITAL_DISCOUNT_MODAL_VIEWED = 'Welcome Digital Discount Modal Viewed';
export const WELCOME_DIGITAL_DISCOUNT_MODAL_CLOSED = 'Welcome Digital Discount Modal Closed';
export const WELCOME_DIGITAL_DISCOUNT_BANNER_SHOWED = 'Welcome Digital Discount Banner Showed';

// Special Discount (Hot Sale / Festival de Viajes) Events
export const SPECIAL_DISCOUNT_BANNER_SHOWED = 'Special Discount Banner Showed';
export const URGENCY_BANNER_SHOWN = 'Urgency Banner Shown';
export const DISCOUNT_UI_SHOWN = 'Discount UI Shown';

export const DOTERS_LOGIN_ALERT_SHOWN = 'Doters Session Expired Dialog Shown';
export const THREE_DS_REDIRECTED = '3DS Redirected';

// Days Carousel Events
export const DAYS_CAROUSEL_VIEWED = 'Days Carousel Viewed';
export const DAYS_CAROUSEL_DAY_SELECTED = 'Days Carousel Day Selected';
export const DAYS_CAROUSEL_SCROLLED = 'Days Carousel Scrolled';
export const DAYS_CAROUSEL_PRICES_LOADED = 'Days Carousel Prices Loaded';

// Cybersource digital-card recommendation
export const DIGITAL_CARD_RECOMMENDATION_SHOWED = 'Digital Card Recommendation Showed';

// Billing company events
export const COMPANY_SEARCH_PERFORMED = 'Company Search Performed';
export const COMPANY_FOUND = 'Company Found';
export const COMPANY_NOT_FOUND = 'Company Not Found';
export const COMPANY_CREATE_OPENED = 'Company Create Opened';
export const COMPANY_CREATED = 'Company Created';
export const COMPANY_CREATION_FAILED = 'Company Creation Failed';
export const COMPANY_SELECTION_CLEARED = 'Company Selection Cleared';

// After midnight section
export const AFTER_MIDNIGHT_SECTION_SHOWN = 'After Midnight Section Shown';
